<template>
    <v-container fluid v-if="dispositivo">
        <v-btn icon variant="text" class="mb-2" @click="tornaIndietro">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        {{ dispositivo.nome }}
                        <v-chip class="ml-3" size="small" variant="flat">
                            {{ dispositivo.tipoDispositivoSicurezzaNome }}
                        </v-chip>
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" variant="text" prepend-icon="mdi-pencil"
                            @click="dialogModifica = true">
                            Modifica
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <strong>Ubicazione:</strong>
                                {{ dispositivo.repartoNome || dispositivo.mezzoNome || dispositivo.sedeNome || '—' }}
                            </v-col>
                            <v-col cols="12" sm="4">
                                <strong>Data acquisto:</strong> {{ formatData(dispositivo.dataAcquisto) }}
                            </v-col>
                        </v-row>
                        <div class="mt-2" v-if="dispositivo.note"><strong>Note:</strong> {{ dispositivo.note }}</div>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Contenuti
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="apriNuovoContenuto">
                            Nuovo contenuto
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="c in dispositivo.contenuti" :key="c.id" :title="c.nome"
                            :subtitle="descrizioneRiga(c)">
                            <template #prepend>
                                <v-chip size="small" :color="coloreRigaContenuto(c)" variant="flat">
                                    {{ etichettaRigaContenuto(c) }}
                                </v-chip>
                            </template>
                            <template #append>
                                <v-btn icon variant="text" size="small" title="Storico sostituzioni"
                                    @click="apriStorico(c)">
                                    <v-icon size="small">mdi-history</v-icon>
                                </v-btn>
                                <template v-if="puoScrivere">
                                    <v-btn size="small" variant="text" color="success" @click="apriSostituisci(c)">
                                        Sostituisci
                                    </v-btn>
                                    <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(c)">
                                        <v-icon size="small">mdi-content-copy</v-icon>
                                    </v-btn>
                                    <v-btn icon variant="text" size="small" @click="apriModificaContenuto(c)">
                                        <v-icon size="small">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon variant="text" size="small" color="error"
                                        @click="chiediEliminazione(c)">
                                        <v-icon size="small">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="dispositivo.contenuti.length === 0">
                            <span class="text-medium-emphasis">Nessun contenuto registrato.</span>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>

        <dialog-dispositivo-sicurezza v-model="dialogModifica" :dispositivo="dispositivo" @salvato="carica" />

        <dialog-contenuto-sicurezza v-model="dialogContenuto" :dispositivo-sicurezza-id="id"
            :contenuto="contenutoSelezionato" @salvato="carica" />

        <dialog-sostituisci-contenuto v-model="dialogSostituisci" :contenuto="contenutoSelezionato"
            :dispositivo-sicurezza-id="id" @sostituito="carica" />

        <dialog-storico-contenuto v-model="dialogStorico" :contenuto-id="contenutoSelezionato?.id" />

        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>Il contenuto verrà rimosso.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import DialogDispositivoSicurezza from "@/components/sicurezza/DialogDispositivoSicurezza.vue";
import DialogContenutoSicurezza from "@/components/sicurezza/DialogContenutoSicurezza.vue";
import DialogSostituisciContenuto from "@/components/sicurezza/DialogSostituisciContenuto.vue";
import DialogStoricoContenuto from "@/components/sicurezza/DialogStoricoContenuto.vue";
import { coloreRigaContenuto, etichettaRigaContenuto } from "@/constants/statoContenutoSicurezza.js";

export default {
    name: "DispositivoSicurezzaDettaglioPage",

    components: {
        DialogDispositivoSicurezza,
        DialogContenutoSicurezza,
        DialogSostituisciContenuto,
        DialogStoricoContenuto,
    },

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            dialogModifica: false,
            dialogContenuto: false,
            dialogSostituisci: false,
            dialogStorico: false,
            dialogElimina: false,
            contenutoSelezionato: null,
        };
    },

    computed: {
        dispositivo() {
            return this.$store.getters["dispositiviSicurezza/corrente"];
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.carica();
            },
        },
    },

    methods: {
        coloreRigaContenuto,
        etichettaRigaContenuto,

        tornaIndietro() {
            this.$router.push("/sicurezza");
        },

        async carica() {
            try {
                await this.$store.dispatch("dispositiviSicurezza/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
        },

        apriNuovoContenuto() {
            this.contenutoSelezionato = null;
            this.dialogContenuto = true;
        },

        apriModificaContenuto(c) {
            this.contenutoSelezionato = c;
            this.dialogContenuto = true;
        },

        apriSostituisci(c) {
            this.contenutoSelezionato = c;
            this.dialogSostituisci = true;
        },

        apriStorico(c) {
            this.contenutoSelezionato = c;
            this.dialogStorico = true;
        },

        async duplica(c) {
            try {
                await this.$store.dispatch("contenutiSicurezza/duplica", { id: c.id, dispositivoSicurezzaId: this.id });
                await this.carica();
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(c) {
            this.contenutoSelezionato = c;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("contenutiSicurezza/elimina", {
                    id: this.contenutoSelezionato.id,
                    dispositivoSicurezzaId: this.id,
                });
                await this.carica();
            } catch (error) {
                console.log(error);
            }
            this.dialogElimina = false;
        },

        descrizioneRiga(c) {
            const data = c.sostituito ? c.dataSostituzione : c.dataScadenza;
            const etichetta = c.sostituito ? "sostituito il" : "scade il";
            const parti = [data ? `${etichetta} ${new Date(data).toLocaleDateString("it-IT")}` : (c.sostituito ? "" : "nessuna scadenza")];
            if (c.quantita) parti.push(`quantità ${c.quantita}`);
            return parti.filter(Boolean).join(" · ");
        },

        formatData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "—";
        },
    },
};
</script>
